import { Component, Input, OnDestroy, OnInit } from "@angular/core";
import { RowTable } from "@shared/schemas/row-table";
import { TableCheckboxService } from "@shared/services/table-checkbox.service";

@Component({
	selector: "app-table-checkbox",
	templateUrl: "./table-checkbox.component.html",
	styleUrls: ["./table-checkbox.component.scss"],
	standalone: false
})
export class TableCheckboxComponent implements OnInit, OnDestroy {
	constructor(private tableCheckboxService: TableCheckboxService) {}

	@Input() value!: RowTable;
	@Input() resetAllStatusOnDestroy = false;
	checked = false;

	ngOnInit(): void {
		if (this.value.isChecked) {
			this.checked = this.value.isChecked;
		}
	}

	ngOnDestroy(): void {
		if (this.resetAllStatusOnDestroy) {
			this.value.isChecked = false;
		}
	}

	newChangedElement(element: HTMLInputElement): void {
		if (this.value) {
			this.value.isChecked = element.checked;
			this.tableCheckboxService.newElement(this.value);
		}
	}
}
